export default "__VITE_ASSET__B4g_7ltI__"